export type JsonValue = boolean | JsonArray | JsonObject | null | number | string;
export interface JsonArray extends Array<JsonValue> {}
export interface JsonObject extends Record<string, JsonValue> {}

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
}

export enum HttpStatusCode {
  Http200Ok = 200,
  Http201Ok = 201,
  Http204Ok = 204,
  Http400BadRequest = 400,
  Http401Unauthorized = 401,
  Http403Forbidden = 403,
  Http404NotFound = 404,
  Http405MethodNotAllowed = 405,
  Http408RequestTimeout = 408,
  Http409Conflict = 409,
  Http429TooManyRequests = 429,
  Http500InternalServerError = 500,
  Http502BadGateway = 502,
  Http503ServiceUnavailable = 503,
  Http504GatewayTimeout = 504,
}
